import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useEffect, useState } from "react";
import CustomersInfoTabs from "./CustomersInfoTabs";
import BulkReactivateAndTransferModal from "./sub-component/Modals/BulkReactivateAndTransferModal";
import CustomerActionsModal from "./sub-component/Modals/CustomerActionsModal";
import BulkApprovalAndRejectCustomerModal from "./sub-component/Modals/BulkApproveAndRejectCustomerModal";
import AddActivityChemistModal from "./sub-component/Modals/AddActivityChemistModals";
import RemoveActivityChemistModal from "./sub-component/Modals/RemoveActivityChemistModals";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import Actions from "../../../../common/enums/Actions";
import Panels from "../../../../common/enums/Panels";
import {
  DisableApproveButton,
  DisableDeactivateButton,
  DisableReactivateButton,
  DisableTransferButton,
} from "../../../../common/utils/ReportsFilters";
import { Constants } from "../../../../common/constants";
import Swal from "sweetalert2";
import FailedTransferModal from "./sub-component/Modals/FailedTransferModal";
import ProgressBarModal from "./sub-component/Modals/ProgressBarModal";
import ReportScreen from "../../../../common/enums/ReportScreens";
import Roles from "../../../../common/enums/Roles";

type FormFields = {
  zone: string;
  region: string;
  area: string;
  hq: string;
  brick: string;
  reason: string;
  reasonSelect: string;
  department: string;
};

type props = {
  isRestricted: Boolean;
  buttonAccess: Boolean;
  type: string;
};

const CustomerDetails: React.FC<props> = ({
  isRestricted,
  buttonAccess,
  type,
}) => {
  const {
    downloadExcel,
    customerIds,
    selectedPanel,
    filterStore,
    userRole,
    panelName,
    reactivateUser,
    fetchCustomerData,
    updateCustomerMapping,
    fetchCustomerSummaryCount,
    showSegement,
    showAddSegement,
    filterSegement,
    addMetaData,
    removeMetaData,
    departmentCode,
    headquarterCode,
    handleClearSelectedCustomers,
    setTitle,
    setProgressCount,
    title,
    mappingIds,
    clearFailedDeactivates,
    customerMetadata,
    decodeToken,
  } = CustomerDatabaseStore();
  const {
    fetchDepartment,
    departmentData,
    headquarterMasterData,
    customerTypesData,
    teamData,
  } = TerritoryDataStore();

  const [openRemoveMapping, setOpenRemoveMapping] = useState<boolean>(false);
  const [openDeactivateUser, setOpenDeactivateUser] = useState<boolean>(false);
  const [segementName, setSegementName] = useState<string>("");
  const [openApproveCustomerModal, setOpenApproveCustomerModal] =
    useState<boolean>(false);
  const [openReactivateCustomerModal, setOpenReactivateCustomerModal] =
    useState<boolean>(false);
  const [openTransferCustomerModal, setOpenTransferCustomerModal] =
    useState<boolean>(false);
  const [openAddActivityChemist, setOpenAddActivityChemist] =
    useState<boolean>(false);
  const [openRemoveActivityChemist, setOpenRemoveActivityChemist] =
    useState<boolean>(false);
  const [openProgressBarModal, setOpenProgressBarModal] =
    useState<boolean>(false);
  const [openFailedTransferModal, setOpenFailedTransferModal] =
    useState<boolean>(false);

  

  const downloadFile = () => {
    filterStore.download = 1;
    Swal.fire({
      title: "Please wait...",
      text: "Your report is being generated.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // API call
    downloadExcel(filterStore)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Excel Report Sent!",
          text: "Your Excel report has been sent to your official email ID.",
          timer: 3000,
          showConfirmButton: false,
        });
      })
      .catch((error: any) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to send the Excel report. Please try again.",
          confirmButtonText: "OK",
        });
        console.error("API Error:", error);
      });
  };


  const handleOpenReactivateCustomerModal = () => {
    setOpenReactivateCustomerModal(true);
  };

  const handleCloseReactivateCustomerModal = () => {
    setOpenReactivateCustomerModal(false);
  };

  const handleOpenApproveCustomerModal = () => {
    setOpenApproveCustomerModal(true);
  };

  const handleCloseApproveCustomerModal = () => {
    setOpenApproveCustomerModal(false);
  };

  const handleOpenTransferCustomerModal = () => {
    setOpenTransferCustomerModal(true);
  };

  const handleCloseTransferCustomerModal = () => {
    setOpenTransferCustomerModal(false);
  };

  const handleOpenAddActivityChemistModal = () => {
    setOpenAddActivityChemist(true);
  };

  const handleCloseAddActivityChemistModal = () => {
    setOpenAddActivityChemist(false);
  };

  const handleOpenRemoveActivityChemistModal = () => {
    setOpenRemoveActivityChemist(true);
  };

  const handleCloseRemoveActivityChemistModal = () => {
    setOpenRemoveActivityChemist(false);
  };

  useEffect(() => {
    decodeToken();
    fetchDepartment();
  }, []);

  const handleModal = (modalName: string) => {
    if (modalName === Actions.BULK_REMOVE_MAPPING) {
      setOpenRemoveMapping(!openRemoveMapping);
    } else if (modalName === Actions.BULK_DEACTIVATE_CUSTOMERS) {
      setOpenDeactivateUser(!openDeactivateUser);
    } else if (modalName === Actions.BULK_APPROVE_REJECT_CUSTOMER) {
      setOpenApproveCustomerModal(!setOpenApproveCustomerModal);
    }
  };

  async function transferCustomerProgress(
    customer_ids: number[],
    payload: any,
    index = 0
  ) {
    const customerSubName = customerTypesData.find(
      (item) => item.id === filterStore.customer_type_id
    );
    const newHeadquarterCode = headquarterMasterData.find(
      (item) => item.id.toString() === payload.headquarter_id.toString()
    );
    const transferPayload = {
      customer_sub_name: customerSubName?.sub_name,
      customer_id: customerIds[index],
      brick_id: payload.brick_id,
      headquarter_id: payload.headquarter_id,
      headquarter_code: newHeadquarterCode?.ga_code,
      department_code: payload.department_code,
      old_headquarter_code: filterStore.headquarter_code,
      mapping_id: mappingIds[index],
      team_id: filterStore.team_id,
      reason: payload.reason,
    };
    if (index < customer_ids.length) {
      setProgressCount(index);
      setTitle("Transfer");
      setOpenProgressBarModal(true);

      let result = await updateCustomerMapping(
        transferPayload,
        customer_ids[index],
        false
      );

      await transferCustomerProgress(customer_ids, transferPayload, index + 1);
    } else {
      setOpenFailedTransferModal(true);
      setOpenProgressBarModal(false);
    }
  }
  async function reactivateCustomerProgress(
    customer_ids: number[],
    payload: any,
    index = 0
  ) {
    const customerSubName = customerTypesData.find(
      (item) => item.id === filterStore.customer_type_id
    );
    const newHeadquarterCode = headquarterMasterData.find(
      (item) => item.id.toString() === payload.headquarter_id.toString()
    );
    const headquarterCode = headquarterMasterData.find(
      (item) => item.id.toString() === filterStore.headquarter_ids[0]
    );
    const reactivatePayload = {
      customer_sub_name: customerSubName?.sub_name,
      customer_id: customerIds[index],
      mapping_id: mappingIds[index],
      old_headquarter_code: headquarterCode?.ga_code,
      brick_id: payload.brick_id,
      headquarter_code: newHeadquarterCode?.ga_code,
      headquarter_id: payload.headquarter_id,
      department_code: payload.department_code,
      team_id: filterStore.team_id,
      reason: payload.reason,
    };

    if (index < customer_ids.length) {
      setProgressCount(index);
      setOpenProgressBarModal(true);
      setTitle("Reactivate");
      let result = await reactivateUser(
        reactivatePayload,
        customer_ids[index],
        false
      );

      await reactivateCustomerProgress(customer_ids, payload, index + 1);
    } else {
      setOpenFailedTransferModal(true);
      setOpenProgressBarModal(false);
    }
  }

  const handleTransferCustomers = (payload: FormFields) => {
    const transferPayload = {
      reason:
        payload.reasonSelect === "Other"
          ? payload.reason
          : payload.reasonSelect,
      brick_id: payload.brick,
      headquarter_id: payload.hq,
      department_code: payload.department,
    };
    clearFailedDeactivates();
    transferCustomerProgress(customerIds, transferPayload)
      .then(() => {
        handleCloseTransferCustomerModal();
        fetchCustomerSummaryCount(filterStore);
        fetchCustomerData();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          timer: 3000,
          text: "Unknown Error Occured! Try Again",
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
      });
  };

  const handleReactivateCustomers = (payload: FormFields) => {
    const reactivatePayload = {
      reason:
        payload.reasonSelect === "Other"
          ? payload.reason
          : payload.reasonSelect,
      brick_id: payload.brick,
      headquarter_id: payload.hq,
      department_code: payload.department,
    };

    clearFailedDeactivates();
    reactivateCustomerProgress(customerIds, reactivatePayload)
      .then(() => {
        handleCloseReactivateCustomerModal();
        fetchCustomerSummaryCount(filterStore);
        fetchCustomerData();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          timer: 3000,
          text: "Unknown Error Occured! Try Again",
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
      });
  };
  const handleAddActivityChemist = () => {
    const department_Code = departmentData.find(
      (type) => type.id === parseInt(departmentCode)
    );
    const addActivityChemistPayload = {
      customer_ids: customerIds,
      headquarter_code: headquarterCode,
      department_code: department_Code?.code,
      metadata_code: filterSegement[0],
    };
    addMetaData(addActivityChemistPayload, handleClearSelectedCustomers);
  };
  const handleRemoveActivityChemist = (reason: string) => {
    const department_Code = departmentData.find(
      (type) => type.id === parseInt(departmentCode)
    );
    const removeActivityChemistPayload = {
      customer_ids: customerIds,
      headquarter_code: headquarterCode,
      department_code: department_Code?.code,
      metadata_code: filterSegement[0],
      reason: reason,
    };
    removeMetaData(removeActivityChemistPayload, handleClearSelectedCustomers);
  };

  const team = teamData.find(
    (type) => type.id.toString() === filterStore.team_id?.toString()
  );
  useEffect(() => {
    const selectedSegement = customerMetadata.find(
      (meta) => meta.code === filterSegement[0]
    )?.name;
    if (selectedSegement) {
      setSegementName(selectedSegement);
    }
  }, [filterSegement]);

  const GetSelectedMenuItem = () => {
    const option = [
      {
        condition:
          type !== ReportScreen.BRICK_MANAGEMENT &&
          filterSegement.length === 0 &&
          buttonAccess &&
          panelName !== Panels.PENDING_APPROVAL &&
          panelName !== Panels.ARCHIVED &&
          panelName !== Panels.PENDING_MAPPING &&
          !DisableDeactivateButton(
            userRole.role,
            customerIds.length,
            selectedPanel,
            panelName,
            filterStore.customer_type_id
          ),
        component: (
          <MenuItem
            value={1}
            onClick={() => handleModal(Actions.BULK_DEACTIVATE_CUSTOMERS)}
            title="Click to Deactivate Customer"
          >
            Deactivate Customers
          </MenuItem>
        ),
      },
      {
        condition:
          filterSegement.length === 0 &&
          !isRestricted &&
          panelName === Panels.ARCHIVED &&
          !DisableReactivateButton(
            userRole.role,
            customerIds.length,
            selectedPanel
          ),
        component: (
          <MenuItem
            value={2}
            onClick={() => handleOpenReactivateCustomerModal()}
            title="Click to Reactivate Customer"
          >
            Reactivate Customers
          </MenuItem>
        ),
      },
      {
        condition:
          (type === ReportScreen.BRICK_MANAGEMENT &&
            filterStore.customer_type_id !== "") ||
          (filterSegement.length === 0 &&
            buttonAccess &&
            panelName !== Panels.PENDING_APPROVAL &&
            panelName !== Panels.ARCHIVED &&
            !DisableTransferButton(
              userRole.role,
              customerIds.length,
              selectedPanel,
              filterStore.headquarter_ids
            )),
        component: (
          <MenuItem
            value={3}
            onClick={() => handleOpenTransferCustomerModal()}
            title="Click to Transfer Customer"
          >
            Transfer Customers
          </MenuItem>
        ),
      },
      {
        condition:
          filterSegement.length === 0 &&
          panelName === Panels.PENDING_APPROVAL &&
          !DisableApproveButton(
            userRole.role,
            customerIds.length,
            selectedPanel
          ),
        component: (
          <MenuItem
            value={4}
            onClick={() => handleOpenApproveCustomerModal()}
            title="Click to Approve And Reject Customer"
          >
            Approve And Reject Customers
          </MenuItem>
        ),
      },
      {
        condition: panelName === Panels.ALL && showSegement,
        component: showAddSegement ? (
          <MenuItem
            value={5}
            onClick={() => handleOpenAddActivityChemistModal()}
            title={`Click to Add ${segementName}`}
          >
            Add {segementName}
          </MenuItem>
        ) : (
          <MenuItem
            value={6}
            onClick={() => handleOpenRemoveActivityChemistModal()}
            title={`Click to Remove ${segementName}`}
          >
            Remove {segementName}
          </MenuItem>
        ),
      },
    ];
    return option
      .filter((option) => option.condition)
      .map((option) => option.component).length === 0 ? (
      <MenuItem disabled value={0}>
        No Action Available
      </MenuItem>
    ) : (
      option
        .filter((option) => option.condition)
        .map((option) => option.component)
    );
  };

  return (
    <Stack>
      {!selectedPanel && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6" color="primary.dark" fontWeight={550}>
            List of all Customers
          </Typography>

          <Stack direction="row" gap={2}>
            {userRole.role !== Roles.AUDIT_TEAM && (
              <Button
                variant="contained"
                startIcon={<FileDownloadOutlinedIcon />}
                sx={{ borderRadius: "30px" }}
                disabled={customerIds.length !== 0 || selectedPanel}
                onClick={downloadFile}
                color="primary"
              >
                <Typography variant="subtitle2" textTransform={"none"}>
                  Download Excel
                </Typography>
              </Button>
            )}
            <Tooltip
              title={
                type === ReportScreen.CUSTOMER_DATABASE &&
                filterStore?.headquarter_ids?.length === 0 &&
                customerIds.length === 0 &&
                filterStore?.team_id?.length === 0
                  ? "Please select headquarter filter, team filter and customer to enable."
                  : customerIds.length === 0 &&
                    filterStore?.team_id?.length === 0
                  ? "Please select team filter && customer to enable."
                  : customerIds.length === 0
                  ? "Please select Customer to enable."
                  : ""
              }
              arrow
            >
              <FormControl
                sx={{ width: "300px" }}
                size="small"
                disabled={
                  panelName === Panels.PENDING_MAPPING ||
                  customerIds.length === 0 ||
                  filterStore.customer_type_id === "" ||
                  (type === ReportScreen.CUSTOMER_DATABASE &&
                    (filterStore?.headquarter_ids?.length === 0 ||
                      filterStore?.team_id?.length === 0))
                }
              >
                <InputLabel>Action</InputLabel>
                <Select label="Action">{GetSelectedMenuItem()}</Select>
              </FormControl>
            </Tooltip>
          </Stack>
        </Stack>
      )}
      {type !== ReportScreen.BRICK_MANAGEMENT && <CustomersInfoTabs />}

      {openReactivateCustomerModal && (
        <BulkReactivateAndTransferModal
          open={openReactivateCustomerModal}
          handleClose={handleCloseReactivateCustomerModal}
          successCallback={handleReactivateCustomers}
          title="Reactivate"
          reasonOptions={Constants.REACTIVATE_REASONS}
          type={type}
        />
      )}
      {openTransferCustomerModal && (
        <BulkReactivateAndTransferModal
          open={openTransferCustomerModal}
          handleClose={handleCloseTransferCustomerModal}
          successCallback={handleTransferCustomers}
          title="Transfer"
          reasonOptions={Constants.TRANSFER_REASONS}
          type={type}
        />
      )}
      {openDeactivateUser && (
        <CustomerActionsModal
          open={openDeactivateUser}
          handleClose={handleModal}
          title={Actions.BULK_DEACTIVATE_CUSTOMERS}
          button="Deactivate"
          setOpenProgressBarModal={setOpenProgressBarModal}
          setOpenFailedTransferModal={setOpenFailedTransferModal}
          reasonOptions={Constants.DEACTIVATE_REASONS}
        />
      )}
      {openApproveCustomerModal && (
        <BulkApprovalAndRejectCustomerModal
          open={openApproveCustomerModal}
          handleClose={handleModal}
          setOpenProgressBarModal={setOpenProgressBarModal}
          setOpenFailedTransferModal={setOpenFailedTransferModal}
          title={Actions.BULK_APPROVE_REJECT_CUSTOMER}
          button="Reject"
          reasonOptions={Constants.BULK_APPROVE_REJECT_CUSTOMERS}
        />
      )}
      {openAddActivityChemist && (
        <AddActivityChemistModal
          open={openAddActivityChemist}
          handleClose={handleCloseAddActivityChemistModal}
          successCallback={handleAddActivityChemist}
          reasonOptions={Constants.REACTIVATE_REASONS}
          title={segementName}
        />
      )}
      {openRemoveActivityChemist && (
        <RemoveActivityChemistModal
          open={openRemoveActivityChemist}
          handleClose={handleCloseRemoveActivityChemistModal}
          successCallback={handleRemoveActivityChemist}
          reasonOptions={Constants.REACTIVATE_REASONS}
          title={segementName}
        />
      )}
      {openProgressBarModal && (
        <ProgressBarModal
          open={openProgressBarModal}
          handleClose={() => {}}
          title={title}
        />
      )}
      {openFailedTransferModal && (
        <FailedTransferModal
          open={openFailedTransferModal}
          teamName={team?.name ? team.name : ""}
          handleClose={() => {
            setOpenFailedTransferModal(false);
          }}
          title={title}
        />
      )}
    </Stack>
  );
};
export default CustomerDetails;
